const downloadConversionDestination = "AW-18261675999/Wc_vCN2_gPEcEN-f7INE";
const conversionTimeoutMs = 1500;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    __claweaseHasAdvertisingConsent?: () => boolean;
    __claweaseLoadGoogleAds?: () => boolean;
    __claweaseRedactedTrackingUrl?: () => string;
    __claweaseWithSensitiveTrackingContext?: (callback: () => void, restoreDelay?: number) => void;
  }
}

function reportDownloadConversion(): Promise<void> {
  return new Promise((resolve) => {
    let completed = false;
    const complete = () => {
      if (completed) return;
      completed = true;
      window.clearTimeout(timeout);
      resolve();
    };
    // A blocked or slow Google tag must never prevent the file download.
    const timeout = window.setTimeout(complete, conversionTimeoutMs);

    try {
      if (!window.__claweaseHasAdvertisingConsent?.()) {
        complete();
        return;
      }

      window.__claweaseLoadGoogleAds?.();
      if (typeof window.gtag !== "function") {
        complete();
        return;
      }

      const send = () => window.gtag?.("event", "conversion", {
        send_to: downloadConversionDestination,
        page_location: window.__claweaseRedactedTrackingUrl?.()
          ?? `${window.location.origin}${window.location.pathname}`,
        event_callback: complete,
        event_timeout: conversionTimeoutMs,
      });

      // Let Google attribute prior ad clicks from its cookies even when the
      // current download URL no longer contains a gclid or utm_source.
      if (window.__claweaseWithSensitiveTrackingContext) {
        window.__claweaseWithSensitiveTrackingContext(send, conversionTimeoutMs);
      } else {
        send();
      }
    } catch {
      complete();
    }
  });
}

/** Count a resolved download request, then hand the installer URL to the browser. */
export async function startTrackedDownload(downloadUrl: string) {
  const url = new URL(downloadUrl);
  if (url.protocol !== "https:" && url.protocol !== "http:") {
    throw new Error("Invalid download URL");
  }
  await reportDownloadConversion();
  window.location.assign(url.href);
}
